import { IconButton } from '@mui/material'
import { format } from 'date-fns';
import React, { useContext } from 'react'
import { SubscriptionPayment } from '../models/SubscriptionPayment';
import DownloadIcon from '@mui/icons-material/Download';
import useDownloadFetch from '../hooks/useDownloadFetch';
import { downloadBillingDocument } from '../config/apiRoutes';
import UserContext from '../contexts/UserContext';
import { useTranslation } from 'react-i18next';
import AlternatingTableRow from '../table/AlternatingTableRow';
import StandardTableCell from '../table/StandardTableCell';

type Props = {
    payment: SubscriptionPayment;
    index: number;
}

const InvoiceTableRow = ({ payment, index }: Props) => {
    const { download } = useDownloadFetch();
    const { selectedRestaurant } = useContext(UserContext);
    const { t } = useTranslation();

    async function downloadInvoicePdf(payment: SubscriptionPayment) {
        if (selectedRestaurant == null) return;
        const url = downloadBillingDocument.replace(":restaurantShortName", selectedRestaurant.restaurantShortName).replace(":paymentId", payment.id.toString());
        download(url, payment.barionId + ".pdf", "GET")
    }

    return (
        <AlternatingTableRow index={index}>
            <StandardTableCell>
                {format(new Date(payment.createdAt), "yyyy-MM-dd")}
            </StandardTableCell>
            <StandardTableCell>
                {payment.paymentRecurrence != null && (
                    <>
                        {t(`payment.subscription_plans.${payment.paymentRecurrence.subscriptionPrice.planId}`)} - {t(`payment.subscription_interval_payment_name.${payment.paymentRecurrence.subscriptionPrice.interval}`)}
                    </>
                )}
            </StandardTableCell>
            <StandardTableCell align='center' className="w-[100px]">
                {payment.amount.toLocaleString()} Ft
            </StandardTableCell>
            <StandardTableCell align="center" className="w-[80px]">
                {payment.billingoId != null && (
                    <IconButton
                        onClick={() => downloadInvoicePdf(payment)}
                    >
                        <DownloadIcon />
                    </IconButton>
                )}
            </StandardTableCell>
        </AlternatingTableRow>
    )
}

export default InvoiceTableRow